import {AsYouType} from 'libphonenumber-js';

export function validatePhoneNumberJP(value, isFormat = false) {
  const phoneNumber = new AsYouType('JP')
  if (isFormat) {
    return phoneNumber.input(value);
  }
  phoneNumber.input(value);
  return phoneNumber.isValid();
}